import { gql } from "@apollo/client";

export const PUT_ENCODED_DATA = gql`
  mutation Markcode_PutEncodedData($input: MarkcodeCryptoData!) {
    mrkcd_PutEncodedData(input: $input) {
      code
      success
      message
    }
  }
`;

export const GET_MESSAGE_DATA = gql`
  query Mrkcd_GetSignData($dataUuid: String) {
    mrkcd_GetSignData(dataUuid: $dataUuid) {
      uuid
      data
    }
  }
`;
